import React, { useState, useCallback } from "react";
import { Col, Form, Input, message, Modal, Row } from "antd";
import { getUrlParams } from "@/utils/utils";
import { Validator } from "@/utils/validator";
import { overrideSecurePass } from "@/services/secure_pass";
import SecurePassText from "@/components/SecurePass/SecurePassText/SecurePassText";

const { TextArea } = Input;

const SecurePassAdminOverridePopup = ({ visible, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [formRef] = Form.useForm();
  const shipmentId = getUrlParams("shipmentId");

  const onSubmit = useCallback(
    async ({ reason }) => {
      try {
        setLoading(true);
        await overrideSecurePass(shipmentId, reason);
        message.success("Override Success");
        formRef?.resetFields();
        onClose?.();
      } catch (error) {
        console.error(error);
        message.error("Override Failed");
      } finally {
        setLoading(false);
      }
    },
    [shipmentId, onClose, formRef],
  );

  return (
    <Modal
      title={
        <span>
          Override <SecurePassText bold /> Validation
        </span>
      }
      open={visible}
      onOk={formRef.submit}
      onCancel={() => {
        onClose?.();
      }}
      confirmLoading={loading}
    >
      <Form layout="vertical" form={formRef} onFinish={onSubmit}>
        <Row gutter={16}>
          <Col flex={1}>
            <p>Please enter reason for validation override.</p>
            <Form.Item name="reason" label="Reason" rules={[Validator.required("Reason is required")]}>
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default SecurePassAdminOverridePopup;
